module.exports = __webpack_public_path__ + "img/wordMobile_icon_menu_default.83bfaf91.svg";